import { render } from "./AddReportModal.vue?vue&type=template&id=f56dcf5c&scoped=true"
import script from "./AddReportModal.vue?vue&type=script&lang=js"
export * from "./AddReportModal.vue?vue&type=script&lang=js"

import "./AddReportModal.vue?vue&type=style&index=0&id=f56dcf5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56dcf5c"]])

export default __exports__